module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-01-on.e19b7a0f.jpg";